import React, { Component } from "react";
import { connect } from "react-redux";
import MetisMenu from "react-metismenu";
import { Link } from "react-router-dom";
import { setOffcanvas } from "../../actions/settingsAction";
import metisMenu from "./metisMenu";
import DefaultLink from "./DefaultLink";
import { Dropdown } from "react-bootstrap";
import { setMiniSidebarMenuOn, setMiniHover } from "../../actions/settingsAction";
import { baseUrl, ROUTE_BASE_URL } from "../../api/common";
import { logOut } from "../Authentication/logout";
import logo from "../../assets/images/logo.png";
import MenuHeader from "./MunuHeader";

class Menu extends Component {
	constructor(props) {
		super(props);
		this.state = {
			showDropdown: false,
		};
		this.toggleSubMenu = this.toggleSubMenu.bind(this);
		this.minisidebarMouseOver = this.minisidebarMouseOver.bind(this);
		this.minisidebarMouseOut = this.minisidebarMouseOut.bind(this);
	}

	handleToggle = (isOpen) => {
		this.setState({ showDropdown: isOpen });
	};

	closeDropdown = () => {
		this.setState({ showDropdown: false });
	};

	toggleSubMenu(e) {
		let menucClass = "";
		if (e.itemId) {
			const subClass = e.items.map((menuItem) => {
				if (["main", "app", "extra", "ui"].includes(menuItem.id)) {
					menucClass = "header";
				}
				menucClass = menuItem.to === this.props.location.pathname ? "" : "collapse";
				return menucClass;
			});
			return subClass;
		} else {
			return e.visible ? "collapse" : "metismenu";
		}
	}

	minisidebarMouseOver() {
		this.props.setMiniSidebarMenuOn(false);
		this.props.setMiniHover(true);
	}

	minisidebarMouseOut() {
		this.props.setMiniSidebarMenuOn(true);
		this.props.setMiniHover(false);
	}

	componentDidMount() {
		document.querySelectorAll("li").forEach((el) => {
			if (["Main", "App", "UI Elements", "Extra"].includes(el.innerText)) {
				el.className = "header";
			}
			else{
				el.className = "header_sub";
			}
		});
	}

	render() {
		if (document.getElementById("left-sidebar") && this.props.miniSidebar) {
			document.getElementById("left-sidebar").addEventListener("mouseover", this.minisidebarMouseOver);
		}
		if (document.getElementById("left-sidebar") && this.props.miniHover) {
			document.getElementById("left-sidebar").addEventListener("mouseout", this.minisidebarMouseOut);
		}

		return (
			<>
				<div id="left-sidebar" className={`sidebar${this.props.miniSideMenuOn ? " mini_sidebar_on" : ""}`}>
					<MenuHeader/>
					<div className="sidebar-scroll">
					  {/* <div className="user-account d-flex">
							<div className="user_div">
								<img
									src={
										localStorage.getItem("loginUserImage")
											? `${baseUrl}/${localStorage.getItem("loginUserImage")}`
											: "../../assets/images/sm/avatar1.jpg"
									}
									className="user-photo"
									alt="User Profile"
								/>
							</div>
							<div className="dropdown">
								<span>Welcome,</span>
								<br />
								<Dropdown show={this.state.showDropdown} onToggle={this.handleToggle} className="ml-0">
									<Dropdown.Toggle variant="success" id="dropdown-basic" className="user-name left_dropdown_btn">
										<strong>{localStorage.getItem("loginUserName") || ""}</strong>
									</Dropdown.Toggle>
									<Dropdown.Menu>
										<Link className="dropdown-item" to={`${ROUTE_BASE_URL}/my-profile`} onClick={this.closeDropdown}>
											<i className="icon-user"></i> My Profile
										</Link>
										<Link className="dropdown-item" to={`${ROUTE_BASE_URL}/`} onClick={this.closeDropdown}>
											<i className="icon-envelope-open"></i> Messages
										</Link>
										<Link className="dropdown-item" to={`${ROUTE_BASE_URL}/`} onClick={this.closeDropdown}>
											<i className="icon-settings"></i> Settings
										</Link>
										<li className="divider" />
										<Link
											className="dropdown-item"
											to={`${ROUTE_BASE_URL}/login`}
											onClick={() => {
												this.closeDropdown();
												logOut();
												console.log("Logging out...");
											}}
										>
											<i className="icon-power"></i> Logout
										</Link>
									</Dropdown.Menu>
								</Dropdown>
							</div>
						</div>   */}
						<nav id="left-sidebar-nav" className="sidebar-nav">
							<MetisMenu
								content={metisMenu}
								noBuiltInClassNames={true}
								classNameItemActive="active"
								classNameContainer={(e) => this.toggleSubMenu(e)}
								classNameContainerVisible="in"
								iconNamePrefix=""
								LinkComponent={(e) => <DefaultLink itemProps={e} />}
							/>
						</nav>
					</div>
				</div>
			</>
		);
	}
}

const mapStateToProps = (state) => ({
	offcanvas: state.settings.offcanvas,
	miniSidebar: state.settings.miniSidebar,
	miniSideMenuOn: state.settings.miniSideMenuOn,
	miniHover: state.settings.miniHover,
});

const mapDispatchToProps = (dispatch) => ({
	setOffcanvas: (e) => dispatch(setOffcanvas(e)),
	setMiniSidebarMenuOn: (e) => dispatch(setMiniSidebarMenuOn(e)),
	setMiniHover: (e) => dispatch(setMiniHover(e)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Menu);